import SpecificationList from './SpecificationList';

export default SpecificationList;
